import { render, staticRenderFns } from "./LedgerReportComponent.vue?vue&type=template&id=048821dc&"
import script from "./LedgerReportComponent.vue?vue&type=script&lang=js&"
export * from "./LedgerReportComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports